/* import __COLOCATED_TEMPLATE__ from './folder-balances.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { Currency, Money } from '@square/dashboard-protos/models/squareup/connect/v2/common/money';
import { AccountScopedIdentifier } from '@square/dashboard-protos/models/squareup/bbfrontend/common/identifier/account_scoped_identifier';
import { AccountState } from '@square/dashboard-protos/models/squareup/banking/common';
import { Action, getEvent, MerchantType, Target, Page } from '@banking/ui/utils/folder-cdp-events';
let FolderBalances = (_dec = service('bbfrontend/v1/withholding-config'), _dec2 = service('bbfrontend/v1/account'), (_class = class FolderBalances extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "automationSubaccountState", _descriptor2, this);
    _initializerDefineProperty(this, "foldersAccounts", _descriptor3, this);
    _initializerDefineProperty(this, "bbFrontendV1WithholdingConfigService", _descriptor4, this);
    _initializerDefineProperty(this, "bbFrontendV1AccountService", _descriptor5, this);
    _initializerDefineProperty(this, "dataApi", _descriptor6, this);
    _defineProperty(this, "emptyBalance", Money.create({
      amount: 0,
      currency: Currency.CAD
    }));
  }
  get hasFolderBalance() {
    return Boolean(this.args.balances?.length);
  }
  async refreshAccounts() {
    const accounts = await this.bbFrontendV1AccountService.listAccounts([AccountScopedIdentifier.create({
      type: AccountScopedIdentifier.TokenType.TOKEN_TYPE_MERCHANT,
      token: this.capitalEngineContext.sessionContext.merchantToken
    })]);
    const accountIds = accounts.filter(a => a.state !== AccountState.CLOSED).map(account => account.id);
    await this.bbFrontendV1WithholdingConfigService.list(accountIds);
  }
  openCreateSubaccountFlow(event) {
    const {
      name,
      properties
    } = getEvent(Action.Click, {
      page: Page.SavingsHomepage,
      target: Target.GetStarted,
      merchantType: this.automationSubaccountState.activeUnits.length > 1 ? MerchantType.MultiUnit : MerchantType.SingleUnit
    });
    this.dataApi.track(name, properties);
    this.args.onOpenCreateFolderFlow();
    event?.target?.deselect();
  }
  closeCreateSubaccountFlow() {
    this.args.onCloseCreateFolderFlow();
    this.automationSubaccountState.resetValues();
  }
  get hasNeverHadFolders() {
    return !this.args.hasDeactivatedAllFoldersAccounts && !this.hasFolderBalance;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "automationSubaccountState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "foldersAccounts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1WithholdingConfigService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1AccountService", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "refreshAccounts", [action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openCreateSubaccountFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openCreateSubaccountFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeCreateSubaccountFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeCreateSubaccountFlow"), _class.prototype)), _class));
export { FolderBalances as default };